module.exports = __webpack_public_path__ + "img/amtrust.f3cd7e64.png";